import * as React from 'react';
import { getAggregationSelectedOption } from '../containers/aggregation/get-selected-options';
import { getGroupBySelectedOption } from '../containers/group-by/get-selected-options';
import { getDistributionSelectedOption } from '../containers/distribution/get-selected-options';
import { getTargetSelectedOption } from '../containers/target/get-selected-options';
import { DisplaySelectedOptions, OptionItem } from 'app/components/display-selected-options/display-selected-options';
import { withCachedTranslation } from 'app/components/enhancers/with-cached-translation';
import { ComplexValue } from 'ui';
import { SelectionFieldItem } from 'app/area/reports/containers/group-by/types-fields';

export interface SelectedOptionsComponentProps {
  selectedAggregationField: ComplexValue<number>;
  selectedAggregationFunction: ComplexValue<number>;
  selectedUomSet: ComplexValue<number>;
  selectedTargetApplication: ComplexValue<number>;
  selectedExposureApplication?: ComplexValue<number>;
  selectedExposureFactor?: number;
  selectedExposurePercent?: number;
  selectedGroupByFields: SelectionFieldItem[];
  translation: any;
}

class SelectedOptionsComponent extends React.PureComponent<SelectedOptionsComponentProps> {
  private selectedOptionsByReportValues = (): OptionItem[] => {
    const {
      selectedAggregationField,
      selectedAggregationFunction,
      selectedUomSet,
      selectedTargetApplication,
      selectedExposureApplication,
      selectedExposureFactor,
      selectedExposurePercent,
      selectedGroupByFields,
      translation
    } = this.props;
    const optionItems: OptionItem[] = [];

    if (selectedAggregationField?.value && selectedAggregationFunction?.value) {
      optionItems.push(getAggregationSelectedOption(
        selectedAggregationField, selectedAggregationFunction, selectedUomSet, translation
      ));
    }
    if (selectedExposureApplication?.value) {
      optionItems.push(getDistributionSelectedOption(
        translation, selectedExposureApplication, selectedExposureFactor, selectedExposurePercent
      ));
    }
    if (selectedGroupByFields && !!selectedGroupByFields.length) {
      optionItems.push(getGroupBySelectedOption(selectedGroupByFields, translation));
    }
    if (selectedTargetApplication?.value) {
      optionItems.push(getTargetSelectedOption(selectedTargetApplication, translation));
    }

    return optionItems;
  };

  public render(): JSX.Element {
    const selectedOptions: OptionItem[] = this.selectedOptionsByReportValues();
    return (
      <DisplaySelectedOptions
        selectedOptions={selectedOptions}
        textHideDetails={this.props.translation.hide_details}
        textShowDetails={this.props.translation.show_details}
      />
    );
  }
}

export const ReportSelectedOptions = withCachedTranslation<SelectedOptionsComponentProps>(SelectedOptionsComponent);
